var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex my-2 px-2",style:(_vm.alignText)},[_c('span',{staticClass:"w-100 unselectable px-2",style:(_vm.fontSize + _vm.background + _vm.color),domProps:{"innerHTML":_vm._s(_vm.templateItemData.content)}})])}
var staticRenderFns = []

export { render, staticRenderFns }